// TODO: move these to constants package
/**
 * Used to determine electrical connectivity between two nodes
 * 0.0002mm = 200nm
 */
export const connectivityTolerance = 0.0002 / 1000;
/**
 * Used to determine whether two traces are part of the same line
 * 0.0002mm = 200nm
 */
export const traceGraphTolerance = 0.0002 / 1000;
/**
 * Add this to the end of a rule to force override the other more important ones
 */
export const pcbRuleImportantString = "!important";
/**
 * Prefix used for naming island vias that connect copper islands across layers
 */
export const ISLAND_VIA_NAME_PREFIX = "Via-Island-";
//# sourceMappingURL=constants.js.map